import { render } from "./PanelTests.vue?vue&type=template&id=329ebd18&scoped=true"
import script from "./PanelTests.vue?vue&type=script&lang=js"
export * from "./PanelTests.vue?vue&type=script&lang=js"

import "./PanelTests.vue?vue&type=style&index=0&id=329ebd18&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329ebd18"],['__file',"src/views/topdog/labs/PanelTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "329ebd18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('329ebd18', __exports__)) {
    console.log('reload')
    api.reload('329ebd18', __exports__)
  }
  
  module.hot.accept("./PanelTests.vue?vue&type=template&id=329ebd18&scoped=true", () => {
    console.log('re-render')
    api.rerender('329ebd18', render)
  })

}


export default __exports__